/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Deliverable_CanvasInputs */



/**
* | output |
* | --- |
* | "A canvas" |
*
* @param {Agent_Builder_Deliverable_CanvasInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_deliverable_canvas = /** @type {((inputs?: Agent_Builder_Deliverable_CanvasInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Deliverable_CanvasInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Canvas")
	return /** @type {LocalizedString} */ ("A canvas")
});